import { render } from "./AddAppItem.vue?vue&type=template&id=000af21b"
import script from "./AddAppItem.vue?vue&type=script&lang=js"
export * from "./AddAppItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\auto-portalV2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__